import { render, staticRenderFns } from "./TablePeopleCounterAnalytics.vue?vue&type=template&id=ebe4baa4"
import script from "./TablePeopleCounterAnalytics.vue?vue&type=script&lang=js"
export * from "./TablePeopleCounterAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports